/*
 * @Date: 2022-07-04 17:34:40
 * @LastEditors: hanhuixian hanhuixian@lxrental.com
 */
export default {
  M: "月",
  Y: "年",
  empty: "暫無數據",
  stockInfo: "股價信息",
  stockInfoRmk: "數據由Refinitiv提供。至少延遲15分鐘。"
}